// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FormattedVolume from "../FormattedVolume/FormattedVolume.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function MeterKeg(props) {
  let keg = props.keg;
  let ariaLabelledby = props.ariaLabelledby;
  let ariaLabel = props.ariaLabel;
  let volume = keg.milliliters;
  return <FormattedVolume.make
    milliliters={Math.max(volume - keg.consumptionsSum | 0, 0)}
  >
    {formattedNumber => <meter
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      title={formattedNumber}
      low={volume / 3 | 0}
      max={volume.toString()}
      min={"0"}
      value={(volume - keg.consumptionsSum | 0).toString()}
    >
      {formattedNumber}
    </meter>}
  </FormattedVolume.make>;
}

let make = MeterKeg;

export {
  make,
}
/* FormattedVolume Not a pure module */
